import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { authApi } from "../api/services";

/**
 * 비밀번호 변경 페이지 컴포넌트
 */
const ChangePassword = ({ onBack }) => {
  const [passwords, setPasswords] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswords((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    
    // 유효성 검사
    if (passwords.newPassword !== passwords.confirmPassword) {
      setError("새 비밀번호가 일치하지 않습니다.");
      return;
    }

    if (passwords.newPassword.length < 4) {
      setError("비밀번호는 4자 이상이어야 합니다.");
      return;
    }

    setLoading(true);
    try {
      // API 호출 (실제 엔드포인트에 맞춰 수정 필요)
      await authApi.changePassword(passwords.currentPassword, passwords.newPassword);
      setSuccess(true);
      setTimeout(() => {
        onBack(); // 성공 후 대시보드로 복귀
      }, 2000);
    } catch (err) {
      // console.error("비밀번호 변경 실패:", err);
      setError(err.response?.data?.message || "비밀번호 변경 중 오류가 발생했습니다.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f5f7fa",
        p: 2,
      }}
    >
      <Paper
        sx={{
          p: 4,
          width: "100%",
          maxWidth: 400,
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <IconButton onClick={onBack} sx={{ mr: 1 }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            비밀번호 변경
          </Typography>
        </Box>

        {success ? (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography color="primary" sx={{ mb: 2, fontWeight: 600 }}>
              비밀번호가 성공적으로 변경되었습니다!
            </Typography>
            <Typography variant="body2" color="textSecondary">
              잠시 후 대시보드로 이동합니다...
            </Typography>
          </Box>
        ) : (
          <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField
              label="현재 비밀번호"
              type="password"
              name="currentPassword"
              fullWidth
              required
              value={passwords.currentPassword}
              onChange={handleChange}
              disabled={loading}
            />
            <TextField
              label="새 비밀번호"
              type="password"
              name="newPassword"
              fullWidth
              required
              value={passwords.newPassword}
              onChange={handleChange}
              disabled={loading}
              helperText="4자 이상 입력해주세요."
            />
            <TextField
              label="새 비밀번호 확인"
              type="password"
              name="confirmPassword"
              fullWidth
              required
              value={passwords.confirmPassword}
              onChange={handleChange}
              disabled={loading}
            />

            {error && (
              <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                {error}
              </Typography>
            )}

            <Button
              type="submit"
              variant="contained"
              fullWidth
              size="large"
              disabled={loading}
              sx={{ mt: 2, py: 1.5, fontWeight: 700 }}
            >
              {loading ? "변경 중..." : "비밀번호 변경하기"}
            </Button>
            
            <Button
              variant="text"
              fullWidth
              onClick={onBack}
              disabled={loading}
              sx={{ color: "text.secondary" }}
            >
              취소
            </Button>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default ChangePassword;
